<template>
    <div class="row mb-3">
        <div class="col-12 col-md-8 d-inline-flex">
            <img class="mr-2" src="/assets/images/doc.svg" alt="Document" />
            <div class="standard">
                <div class="name">{{ standard.Name }} <br /></div>
                <div
                class="title"
                v-html="standard.StandardIntroduction"
                ></div>
            </div>
        </div>
        <div class="col-6 col-md-2 date">{{ status }}</div>
        <div class="col-6 col-md-2">
            <a role="navigation" class="view float-right" @click="routeToStandard()" @keydown.enter="routeToStandard()"  tabindex="0"
                >Review<i class="angle-right-green"></i>
            </a>
        </div>
    </div>
</template>

<script>
import { privateRouter } from '../router';

    export default {
        name: 'OverviewSavedAssessmentsStandard',
        data() {
            return {
                status: ''
            };
        },
        props: {
            standard: {
                type: Object,
                default: () => {}
            },
            satId: {
                type: Number,
                default: () => 0
            }
        },
        created() {
            this.standardCompletionStatus();
        },
        methods: {
            routeToStandard(){
                privateRouter.push({
                    name: 'AssessmentStandard',
                    query: {
                        satId: this.satId,
                        standardId: this.standard.Id
                    }
                });
            },
            standardCompletionStatus() {
                let questions = [];              
                this.standard.Sections.forEach(section => {
                    questions = questions.concat(section.Questions);
                });

                this.status = "Not met"
                let allPostive = true;

                questions.forEach(question => {          
                    if(question.SAT_SavedResponses.NotApplicable == false // NotApplicable should not affect the final status.
                        && ((question.SAT_SavedResponses.PositiveResponse == true || question.SAT_SavedResponses.NegativeResponse == true || question.SAT_SavedResponses.PartialResponse == true) // all unanswered (all false) questions means Not Met
                        || (question.SAT_SavedResponses.PositiveResponse == false && question.SAT_SavedResponses.NegativeResponse == false && question.SAT_SavedResponses.PartialResponse == false && question.SAT_SavedResponses.NotApplicable == false))){  
                        if(question.SAT_SavedResponses.NegativeResponse == true || (question.SAT_SavedResponses.PositiveResponse == false && question.SAT_SavedResponses.NegativeResponse == false && question.SAT_SavedResponses.PartialResponse == false && question.SAT_SavedResponses.NotApplicable == false)){ // leave status unchanged (will be 'not met' if all are negative or unanswered)
                            allPostive = false;
                        } else {
                            if(question.SAT_SavedResponses.PositiveResponse == true && allPostive){ // only fully met if all are Positive
                                this.status = 'Fully met';
                            } else { // if any aren't positive then partially met
                                allPostive = false;
                                this.status = 'Partially met';
                            }
                        }
                    }        
                });
            },  
        }
    }
</script>

<style lang="sass" scoped>

</style>